/**
 * Phone helpers — keep state as raw digits (max 10) and display as (XXX) XXX-XXXX.
 * For submission to backend (Twilio E.164), call toE164(digits).
 */

export function digitsOnly(value) {
  return (value || "").replace(/\D/g, "").slice(0, 10);
}

export function formatPhone(value) {
  const d = digitsOnly(value);
  if (!d) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidUSPhone(value) {
  return digitsOnly(value).length === 10;
}

export function toE164(value) {
  const d = digitsOnly(value);
  if (d.length === 10) return `+1${d}`;
  if (d.length === 11 && d.startsWith("1")) return `+${d}`;
  return d ? `+${d}` : "";
}
